import React, { useState } from 'react';
import tabStyles from 'assets/css/Tab.module.css';
import CertificationExamCard, { CardViewType } from './Card.CertificationExamCard';
import NonProctoredExamCard from './Card.NonProctoredExamCard';
import CardFooter from '../CardFooter';
import CardHeader from '../CardHeader';
import styles from 'assets/css/NPCertificationExam.module.css';
import { useComponentToggle } from 'context/ComponentToggleContext';

const PANEL_TYPE = {
    NON_PROCTORED: {
        id: 'non_proctored',
        label: 'Non-Proctored Exam'
    },
    ACE_CERTIFIED_EXAM: {
        id: 'ace_certified_exam',
        label: 'ACE Certification Exam'
    }
}

const ExamOptionsCard = (props) => {
    const [activePanel, setActivePanel] = useState(props.data.ProctoredExam.CardDisplayType != CardViewType.NO_VOUCHER ? PANEL_TYPE.ACE_CERTIFIED_EXAM.id : PANEL_TYPE.NON_PROCTORED.id);
    const { refreshCardLayout } = useComponentToggle();

    const handleTabChangeResize = () => {
        refreshCardLayout(props.data.Type)
    }

    const nonProctorHeaderProps = {
        ...props.data.NonProctoredExam,
        "title": props.data.NonProctoredCardHeader.Title,
        "cardIconKey": props.data.NonProctoredExam.CardType,
        "type": props.data.NonProctoredExam.CardType,
        "headerText": props.data.NonProctoredCardHeader.HeaderText,
    };

    const NonProctoredPanel = () => (
        <NonProctoredExamCard {...nonProctorHeaderProps} cardTools={props.data.NonProctoredCardHeader.CardTools} />
    );

    const certExamHeaderProps = {
        ...props.data.ProctoredExam,
        "cardIconKey": props.data.ProctoredExam.CardType,
        "cardTitle": props.data.CertificationExamCardHeader.HeaderText,
        "type": props.data.ProctoredExam.CardType,
    };

    const AceCertifiedExamPanel = () => (
        <>
            <CardHeader {...certExamHeaderProps} cardTools={props.data.CertificationExamCardHeader.CardTools}  />
            <CertificationExamCard data={props.data.ProctoredExam} />
            <CardFooter data={props.data.ProctoredExam} />
        </>
    );

    return (
        <div className={'tabbed-card'}>
            <div className={tabStyles.tabWrap} style={{borderBottom: '1px solid #d8e0e2'}}>
                <div className={tabStyles.tabWrapInner}>
                    <TabSelector
                        onTabChange={handleTabChangeResize}
                        panelId={PANEL_TYPE.NON_PROCTORED.id}
                        label={PANEL_TYPE.NON_PROCTORED.label}
                        isActive={activePanel === PANEL_TYPE.NON_PROCTORED.id}
                        setActivePanel={setActivePanel}
                    />
                    <TabSelector
                        onTabChange={handleTabChangeResize}
                        panelId={PANEL_TYPE.ACE_CERTIFIED_EXAM.id}
                        label={PANEL_TYPE.ACE_CERTIFIED_EXAM.label}
                        isActive={activePanel === PANEL_TYPE.ACE_CERTIFIED_EXAM.id}
                        setActivePanel={setActivePanel}
                    />
                </div>
            </div>

            <div className={'panel-container'}>
                {activePanel === PANEL_TYPE.NON_PROCTORED.id && <NonProctoredPanel />}
                {activePanel === PANEL_TYPE.ACE_CERTIFIED_EXAM.id && <AceCertifiedExamPanel />}
            </div>
        </div>
    )
}

const TabSelector = ({onTabChange, panelId, label, isActive, setActivePanel}) => {

    return (
        <div
            className={`${tabStyles.tab} ${isActive ? tabStyles.tabActive : ""}`}
            onClick={() => { setActivePanel(panelId); onTabChange(); }}
        >
            {label}
        </div>
    )
}

export default ExamOptionsCard;
